/*
 * File: cell-multi-hierachy.ts
 * File Created: 2024-06-05 09:47:58
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-09-30 05:49:59
 * Modified By: Val Liu
 * -----
 */

import { BaseTableBodyCell, defaultTableBodyCellData, ITableBodyCellData } from "@root/components/table/core/lib/base-table-body-cell/base-table-body-cell";
import { UITag } from "@root/core/tags";
import { IQuickUnitAny, QuickHelper } from "@root/core/utilities/quick-helper";
import { Component, Prop } from "vue-property-decorator";
import CellSingleHierachy from "../cell-single-hierachy/cell-single-hierachy";

export interface ICellHierachyData {
    /// 不顯示最後一個
    "drop-last"?: boolean;
    /// 隱藏標籤
    "hide-tag"?: boolean;
}
export const defaultData: ICellHierachyData = {
    "drop-last": false,
    "hide-tag": false,
};

@Component
@UITag.setDefault({
    uiAlign: "r",
    uiProvideRow: true,
})
export default class CellHierachy extends BaseTableBodyCell {
    @Prop({ type: Array, required: true })
    quicks!: IQuickUnitAny[];

    @Prop({ type: Object, required: false })
    declare data: (ICellHierachyData & ITableBodyCellData) | undefined;
    get mergedData() {
        return {
            ...defaultTableBodyCellData,
            ...defaultData,
            ...this.data,
        };
    }

    get hierachies() {
        return QuickHelper.buildHierachies(this.quicks).filter((summary) =>
            CellSingleHierachy.matchHierachy(summary, this.value),
        );
    }
}
